import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { AddressContainer } from '../../../../../../common/address/containers/address.container';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { BillingAddressContainer } from '../../../../../../common/billing-address/containers/billing-address.container';
import { ShippingAddressContainer } from '../../../../../../common/shipping-address/containers/shipping-address.container';


export const OrganizationAddressComponent = ({ handleInnerbasicFormChange, onInnerFormChange, organization, openingHoursType, selectedAddress }: any) => (
          <>

                <AddressContainer
                    isAddress
                    onInnerFormChange={onInnerFormChange}
                    selectedAddress={selectedAddress}
                />
  
           
          <AccordionContainer
              child={
                <>
              <div>
                <InputContainer
                    label="Use PrimaryAddress As BillingAddress"
                    name="IsUsePrimaryAddressAsBillingAddress"
                    onValueChange={(event: any) => {
                      handleInnerbasicFormChange(
                        event,
                        'IsUsePrimaryAddressAsBillingAddress'
                      )
                    }}
                    type="checkbox"
                    value={organization?.IsUsePrimaryAddressAsBillingAddress}
                />
           

            {!organization?.IsUsePrimaryAddressAsBillingAddress &&
                <BillingAddressContainer
                    isAddress
                    onInnerFormChange={onInnerFormChange}
                    selectBillingAddress={selectedAddress}
                   
                />}
                </div>
                </>
  }
              expandedPanel="billingaddressInfo"
              headerTitle="Billing Address"
          />
           <AccordionContainer
               child={
                 <>
                <div>
                <InputContainer
                    label="Use Primary Address As ShippingAddress"
                    name="IsUsePrimaryAddressAsShippingAddress"
                    onValueChange={(event: any) => {
                      handleInnerbasicFormChange(
                        event,
                        'IsUsePrimaryAddressAsShippingAddress'
                      )
                    }}
                    type="checkbox"
                    value={organization?.IsUsePrimaryAddressAsShippingAddress}
                />
           
            {!organization?.IsUsePrimaryAddressAsShippingAddress &&
                <ShippingAddressContainer
                    isAddress
                    onInnerFormChange={onInnerFormChange}
                    selectShippingAddress={selectedAddress}
                   
                />}
              </div>
                </>
  }
               expandedPanel="shippingaddressInfo"
               headerTitle="Shipping Address"
           />

</>
)
export default OrganizationAddressComponent;
